module.exports = __webpack_public_path__ + "img/3diamond-02.4f5de898.svg";